import { AssetType } from '../../../../../types/api';
import { PREPAYMENT_PENALTY_SENTENCE } from '../../utils/helpers';
const NOTE = `Please Note: ${PREPAYMENT_PENALTY_SENTENCE}`;

type ShowsNoteInput = {
  selectedAssetTypes: ReadonlyArray<AssetType>;
  loanTerm: string | null | undefined;
  interestRate: number | null | undefined;
};

// Show only after a non-solar asset, a term, and a non-zero rate are selected.
const showsNote = ({
  selectedAssetTypes,
  loanTerm,
  interestRate,
}: ShowsNoteInput): boolean => {
  if (selectedAssetTypes.length === 0) return false;
  if (selectedAssetTypes.includes(AssetType.SOLAR)) return false;
  if (!loanTerm) return false;
  if (interestRate == null || interestRate === 0) return false;
  return true;
};

export const PrepaymentPenalty = {
  NOTE,
  showsNote,
};
